import i18n from 'i18n';
import { FormLabel } from '../form-label';
import LOCALS from 'commons/locals';
import { Control, Controller, UseFormSetValue } from 'react-hook-form';
import { Radio } from 'antd';
import { FieldErrors } from 'react-hook-form';
import { CreateProductFormSchemaType, useGenerateDetailTitle } from '../common';
import useBrandList from 'commons/hooks/use-brand-list';

const ProductBrand = ({
  control,
  errors,
  setValue,
}: {
  control: Control<CreateProductFormSchemaType>;
  errors: FieldErrors<CreateProductFormSchemaType>;
  setValue: UseFormSetValue<CreateProductFormSchemaType>;
}) => {
  const { BrandList: brandList } = useBrandList();
  const { generateDetailTitle } = useGenerateDetailTitle(control);

  return (
    <div className="flex items-center gap-2">
      <FormLabel required>{i18n.t(LOCALS.brand)}:</FormLabel>
      <Controller
        name="brandName"
        control={control}
        render={({ field }) => (
          <div className="relative w-full">
            <Radio.Group
              {...field}
              optionType="button"
              buttonStyle="solid"
              onChange={(e) => {
                field.onChange(e);
                const detailTitle = generateDetailTitle({
                  brandName: e.target.value,
                });
                setValue('detailTitle', detailTitle);
              }}
            >
              {brandList.map(({ value, label }) => {
                return (
                  <Radio value={value} key={value}>
                    {label}
                  </Radio>
                );
              })}
            </Radio.Group>
            {errors.brandName && (
              <p style={{ color: 'red' }} className="absolute left-0">
                {i18n.t(LOCALS.required_field)}
              </p>
            )}
          </div>
        )}
      />
    </div>
  );
};

export default ProductBrand;
